var core = require('./_core');
module.exports = function (CONSTRUCTOR) {
  var C = core[CONSTRUCTOR];
  return (C.virtual || C.prototype);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_entry-virtual.js
// module id = RUAJ
// module chunks = 0